import React from 'react';
import { makeStyles } from '@material-ui/core';
import { colors } from '../../../theme';

const useStyles = makeStyles({
  dotted: {
    border: 0,
    height: 0,
    borderTop: `1px dashed ${colors.silver}`,
  },
});

const DottedHr = (): JSX.Element => {
  const classes = useStyles();
  return <hr className={classes.dotted} />;
};

export default DottedHr;
